import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind class names while resolving conflicts. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Strip the `/assets/models/` prefix and `.glb` suffix for display. */
export function prettyModelName(path: string) {
  return path
    .replace(/^\/?assets\/models\//, '')
    .replace(/\.glb$/i, '')
    .replace(/[_-]/g, ' ');
}

/** Convert a sequence file path like `/sequences/fun.json` to the bare name. */
export function prettySequenceName(file: string) {
  return file.replace(/^.*\//, '').replace(/\.json$/i, '');
}
